export default ({ app, isDev, env }) => {
  if (isDev) {
    app.$cookies.set("netlabs_roadblock", env.roadblockKey, {
      path: "/",
      maxAge: 60 * 60 * 24 * 7,
    });
  }
};
